import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, KeyValuePair, Qualifier, VariableType } from '../../models';
import { IStoreService } from '../../services';
import { StoreElement, Store } from '../../stateManagement';
import { Unsubscribe } from 'redux';
import { getDefaultQualifier } from '../../services/helpers/variable.helper';

class QualifierSelectContoller implements angular.IComponentController {
    properties: KeyValuePair<string, string>[];
    model: string;
    formController: angular.IFormController;
    variableTypeGuid: string;
    disabled: boolean;
    field: string;

    private _unsubscribe: Unsubscribe;
    // resolve when qualifiers are available
    private _hasLoaded: angular.IDeferred<void>;
    private _variableTypes: _.Dictionary<VariableType>;
    private _qualifiers: _.Dictionary<Qualifier>;

    static $inject = ['$q', 'storeService'];

    constructor(
        private _$q: angular.IQService,
        private _storeService: IStoreService,
    ) {
        this._hasLoaded = this._$q.defer<void>();
    }

    $onInit() {
        if (!this.field) {
            this.field = 'qualifierProperty';
        }

        this._unsubscribe = this._storeService.register(
            store => this.loadVariables(store),
            [StoreElement.Variables]
        );
    }

    $onDestroy() {
        this._unsubscribe();
    }

    $onChanges(changes: angular.IOnChangesObject) {
        if (changes['disabled']) {
            this.validate();
        }

        if (changes['variableTypeGuid']) {
            if (changes['variableTypeGuid'].currentValue) {
                this._hasLoaded.promise.then(() => {
                    this.properties = this.getQualifiers(this.variableTypeGuid);
                    const defaultQualifier = getDefaultQualifier(this.model, this.properties);
                    if (defaultQualifier && defaultQualifier !== this.model) {
                        this.model = defaultQualifier;
                    }
                    this.validate();
                });
            } else {
                this.properties = [];
            }
        }
    }

    private loadVariables(store: Store): void {
        this._qualifiers = store.qualifiers.dictionary;
        this._variableTypes = store.variablesTypes.dictionary;
        this._hasLoaded.resolve();
    }

    private getQualifiers(variableTypeGuid: string): KeyValuePair<string, string>[] {
        const vt = this._variableTypes[variableTypeGuid];
        return vt
            ? vt.qualifierCollection
                .map(guid => this._qualifiers[guid])
                .map(q => { return { key: q.guid, value: q.name }; })
            : [];
    }

    private validate() {
        const isValid = this.disabled || (this.properties && (this.properties.length === 0 || _.some(this.properties, p => p.key === this.model)));
        this.formController[this.field]?.$setValidity('required', isValid);
    }

}

export const wtQualifierSelect: ComponentDefinition = {
    componentId: 'wtQualifierSelect',
    controller: QualifierSelectContoller,
    template: require('./qualifierSelect.component.html'),
    controllerAs: 'vm',
    bindings: {
        model: '=',
        formController: '<',
        variableTypeGuid: '<',
        field: '@?',
        disabled: '<?'
    }
};